import { render, staticRenderFns } from "./RecordingComments.vue?vue&type=template&id=2262cdeb&scoped=true&"
import script from "./RecordingComments.vue?vue&type=script&lang=js&"
export * from "./RecordingComments.vue?vue&type=script&lang=js&"
import style0 from "./RecordingComments.vue?vue&type=style&index=0&id=2262cdeb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262cdeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSimpleTable,VSkeletonLoader})
